import { CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Icon,
    Typography,
} from '@mui/material'
import { ReactElement, useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SearchInAPIAndSelectInput from '../../Common/SearchInAPIAndSelectInput'
import { postTransferEntitiesToOrgs } from '../../../services/entityServices'
import { useFetchTransferOrganizations } from '../Hooks/useFetchTransferOrganizations'

interface TransferInstancesModalType {
    templateId: string
    entityIds: string[]
    excludeOrgs: string[]
    onClose: () => void
    onTransfer: () => void
}

const TransferInstancesModal = ({
    templateId,
    entityIds,
    excludeOrgs,
    onClose,
    onTransfer,
}: TransferInstancesModalType): ReactElement => {
    const { t } = useTranslation()
    const [selectedOrg, setSelectedOrg] = useState<{
        id: string
        name: string
    } | null>(null)

    const { orgsList, isFetching, hasMore, onSearch, fetchNextPage } =
        useFetchTransferOrganizations({
            templateId,
            orgId: '',
            excludeOrgs,
            includeVirtualOrgs: true,
        })

    const onSelectOrg = useCallback((id: string, orgs: any) => {
        setSelectedOrg(orgs)
    }, [])
    const handleTransfer = useCallback(async () => {
        if (selectedOrg?.id) {
            const respose = await postTransferEntitiesToOrgs(
                selectedOrg?.id,
                entityIds,
            )
            if (respose.status === 200) {
                onTransfer()
            }
        }
    }, [entityIds, selectedOrg, onTransfer])

    const isTransferDisable = useMemo(() => {
        return !selectedOrg
    }, [selectedOrg])

    return (
        <Dialog
            open={true}
            scroll="paper"
            PaperProps={{
                sx: {
                    width: '400px',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{ padding: '10px 30px' }}
            onClose={() => onClose()}
        >
            <Box>
                <DialogTitle id="scroll-dialog-title" sx={{ padding: '0px' }}>
                    <Box
                        display="flex"
                        alignItems="center"
                        padding="15px"
                        paddingLeft="20px"
                    >
                        <Typography
                            id="transfer-entityIds-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ paddingTop: '10px' }}
                        >
                            {t('organizations')}
                        </Typography>
                        <Icon
                            onClick={() => onClose()}
                            sx={{ marginLeft: 'auto' }}
                            fontSize="small"
                            id="transfer-entites-popup-close-icon"
                        >
                            <CloseOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                    </Box>
                </DialogTitle>
                <DialogContent
                    sx={{
                        height: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Box sx={{ width: 'calc(100%)' }}>
                            <SearchInAPIAndSelectInput
                                id={'organization-list-for-transfer'}
                                label={''}
                                placeholder={t('organization')}
                                required={false}
                                value={selectedOrg}
                                onSelect={onSelectOrg}
                                list={orgsList}
                                onSearch={onSearch}
                                onFetchNextPage={fetchNextPage}
                                hasMore={hasMore}
                                isFetching={isFetching}
                            />
                        </Box>
                        <Box
                            onClick={
                                isTransferDisable
                                    ? () => {}
                                    : () => handleTransfer()
                            }
                        >
                            <Button
                                sx={{
                                    mt: 4,
                                }}
                                variant="contained"
                                fullWidth
                                id="relation-status-submit-button"
                                disabled={isTransferDisable}
                            >
                                {t('transfer')}
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
    )
}

export default TransferInstancesModal
